import React from 'react';
import ImageGallerywe from '../components/ImageGallerywe';
import IRCTVDonationCard from "./IRCTVDonationCard";



const IRCWE = () => {
    const wepBaseAmount = 100;

    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGallerywe />

                    {/* Women Empowerment Programs */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>WOMEN EMPOWERMENT PROGRAMS</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                IRC’s Women Empowerment programs support the social and economic empowerment of women through providing them skill-building training, self-esteem counselling, guidance on liberating themselves by preserving their modesty and access to information and resources that help them to invest in income generating activities and turn them into confident decision-makers and leaders in their homes and communities.
                            </p>
                        </div>
                        <IRCTVDonationCard
                            title="WOMEN EMPOWERMENT PROGRAMS"
                            baseAmount={wepBaseAmount}
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: WOMEN EMPOWERMENT PROGRAMS"
                        />
                    </div>

                </section>
            </div>
        </>
    );
};

export default IRCWE;
